import React, { useEffect } from 'react'
import { ContentModal, Button } from 'ui/acro'
import styled from 'styled-components'
import { useModal_deprecated } from 'hooks'
import { axios } from 'api'

const ModalTitle = styled.div`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -1.2px;
  text-transform: uppercase;
  @media (max-width: 600px) {
    font-size: 28px;
    line-height: 135%;
    letter-spacing: -0.84px;
  }
`

const Description = styled.p`
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.396px;
  display: block;
  margin: 32px 0;
  a {
    color: blue;
    text-decoration: underline;
  }
  @media (max-width: 600px) {
    font-size: 16px;
    letter-spacing: 0.352px;
  }
`
const ContinueButton = styled(Button)`
  font-family: Proxima-nova;
  color: #fff;
  width: 100%;
  max-width: 405px;
  background: #000;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  padding: 12px 32px;
  border-radius: 0;

  @media (max-width: 600px) {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.8px;
    padding: 12px 16px;
  }
`

const Wrapper = styled.div`
  padding: 72px 48px;
  text-align: center;
  @media (max-width: 600px) {
    padding: 64px 16px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const AppleRefundModal = () => {
  const saveClosed = () => {
    axios
      .post('/user_popups', { popup_key: 'awc_apple_refund_popup' })
      .then(() => {})
      .catch((err) => {
        console.log(err)
      })
  }

  const alertModal = useModal_deprecated(saveClosed)
  const hideModal = () => {
    alertModal.close()
  }

  useEffect(() => {
    alertModal.open()
  }, [])

  return (
    <ContentModal
      useModal={alertModal}
      style={{ maxWidth: '862px', borderRadius: 6, border: 'none' }}
    >
      <Wrapper>
        <ModalTitle>{'Subscription Update'}</ModalTitle>
        <Description>
          <b>ALO Wellness Club is now free</b> for everyone
        </Description>
        <Description>
          Your subscription (billed through Apple) was automatically
          transitioned to a free membership, and{' '}
          <b>you'll keep your same access at no cost.</b>
        </Description>

        <Description>
          If you believe you may be eligible for a refund, Apple must review and
          process it directly. You can make your request here: <br />
          <a href={'https://support.apple.com/en-us/118223'}>
            Report a problem (Refund Request).
          </a>
        </Description>

        <Description>
          Thank you for being a valued member of our community. See you on your
          mat.
        </Description>

        <ButtonContainer>
          <ContinueButton onClick={hideModal}>
            Continue to Alo wellness Club
          </ContinueButton>
        </ButtonContainer>
      </Wrapper>
    </ContentModal>
  )
}
